<template>
  <b-modal
    v-model="showFilterModal"
    title="Filter Social Learning"
    size="md"
    hide-footer
    centered
  >
    <div class="filter-form">
      <!-- Type Filter -->
      <div class="mb-3">
        <label class="form-label fw-bold">Type:</label>
        <b-form-select
          v-model="localFilters.type"
          :options="typeOptions"
          class="form-select"
        />
      </div>

      <!-- Competency Filter -->
      <div class="mb-3">
        <label class="form-label fw-bold">Competency:</label>
        <b-form-select
          v-model="localFilters.competency"
          :options="competencyOptions"
          class="form-select"
        />
      </div>

      <!-- Order By -->
      <div class="mb-3">
        <label class="form-label fw-bold">Order By:</label>
        <b-form-select
          v-model="localFilters.order"
          :options="orderOptions"
          class="form-select"
        />
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="d-flex justify-content-end gap-2 mt-4">
      <b-button variant="secondary" @click="resetFilters">
        <i class="fe fe-refresh-cw me-1"></i>
        Reset
      </b-button>
      <b-button variant="outline-secondary" @click="closeModal">
        Cancel
      </b-button>
      <b-button variant="primary" @click="applyFilters">
        <i class="fe fe-check me-1"></i>
        Apply Filter
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "FilterCoaching",
  props: {
    showFilterModal: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    competencyData: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["close", "apply"],
  data() {
    return {
      localFilters: {
        type: "",
        competency: "",
        order: "asc",
      },
      typeOptions: [
        { value: "", text: "All Types" },
        { value: "C", text: "Coaching" },
        { value: "M", text: "Mentoring" },
      ],
      orderOptions: [
        { value: "asc", text: "Ascending" },
        { value: "desc", text: "Descending" },
      ],
    };
  },
  computed: {
    competencyOptions() {
      const options = [{ value: "", text: "All Competencies" }];
      if (this.competencyData && this.competencyData.length > 0) {
        this.competencyData.forEach((comp) => {
          options.push({
            value: comp.competency_id || comp.id,
            text: comp.competency_name || comp.name,
          });
        });
      }
      return options;
    },
  },
  watch: {
    showFilterModal(val) {
      if (val) {
        // Reset local filters when modal opens
        this.localFilters = { ...this.filters };
      } else {
        this.$emit("close");
      }
    },
    filters: {
      handler(newFilters) {
        this.localFilters = { ...newFilters };
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    applyFilters() {
      this.$emit("apply", { ...this.localFilters });
      this.closeModal();
    },
    resetFilters() {
      this.localFilters = {
        type: "",
        competency: "",
        order: "asc",
      };
    },
  },
};
</script>

<style scoped>
.filter-form {
  padding: 0.5rem 0;
}

.form-label {
  color: #6c757d;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.form-select {
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
}

.form-select:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.gap-2 {
  gap: 0.5rem;
}

.btn {
  transition: all 0.2s ease-in-out;
}

.btn:hover {
  transform: translateY(-1px);
}
</style>
